import React from 'react';
import { Lock } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { Button } from "../../components/tailwind/button";
import { waBtn } from "../../pages/whatsapp/utils/whatsappUiTokens";

const WhatsAppConnectionNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="mb-6 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg">
      <div className="flex items-center gap-3">
        <Lock className="h-6 w-6 text-yellow-600 dark:text-yellow-400" />
        <div className="flex-1">
          <h3 className="font-semibold text-yellow-800 dark:text-yellow-200">WhatsApp Not Connected</h3>
          <p className="text-sm text-yellow-700 dark:text-yellow-300">
            You need to connect your WhatsApp Business Account to Meta before you use this feature.
          </p>
        </div>
        <Button
          onClick={() => navigate('/whatsapp/dashboard')}
          className={waBtn.primary}
        >
          Connect with Meta
        </Button>
      </div>
    </div>
  );
};

export default WhatsAppConnectionNotice;